import React from 'react';
import { degreesTab } from '../../copy/advisor-dashboard/careers-degrees-tab.json';
import { EditHighSchoolClassesButton } from './high-school-class-selection/EditHighSchoolClassesButton';

const DegreeDetails = ({ details, showEditButton, chosenTenant }) => {
  return (
    <>
      <div className="details-dropdown__details details-dropdown__degree-details">
        <p className="details-dropdown__details-label">{degreesTab.acadPlan}</p>
        <p className="details-dropdown__details-value">{details.acadPlan}</p>
      </div>
      <div className="details-dropdown__details details-dropdown__degree-details">
        <p className="details-dropdown__details-label">{degreesTab.campus}</p>
        <p className="details-dropdown__details-value">
          {details.campus ? details.campus : degreesTab.NA}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__degree-details">
        <p className="details-dropdown__details-label">{degreesTab.online}</p>
        <p className="details-dropdown__details-value">
          {details.campus?.includes('Online') ? 'Yes' : 'No'}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__degree-details">
        <p className="details-dropdown__details-label">
          {degreesTab.firstMathRequiredEn}
        </p>
        <p className="details-dropdown__details-value">
          {details.firstMathRequiredEn
            ? details.firstMathRequiredEn
            : degreesTab.NA}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__degree-details">
        <p className="details-dropdown__details-label">
          {degreesTab.mathIntensityEn}
        </p>
        <p className="details-dropdown__details-value">
          {details.mathIntensityEn ? details.mathIntensityEn : degreesTab.NA}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__degree-details">
        <p className="details-dropdown__details-label">
          {degreesTab.description}
        </p>
        <p className="details-dropdown__details-value">
          {details.descriptionEn}
        </p>
      </div>
      <div className="details-dropdown__details details-dropdown__degree-details">
        <p className="details-dropdown__details-label">
          {degreesTab.learnMoreURL}
        </p>
        <p className="details-dropdown__details-value">
          {details.institutionInfo[0].url}
        </p>
      </div>
      {showEditButton && (
        <EditHighSchoolClassesButton
          chosenTenant={chosenTenant}
          acadPlan={details.acadPlan}
          tenantName={chosenTenant.name}
        />
      )}
    </>
  );
};

export default DegreeDetails;
